import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgEllipsisStrokeVertical = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 21a2.572 2.572 0 0 1 0-5.143 2.574 2.574 0 0 1 2.571 2.572A2.574 2.574 0 0 1 12 21m.964-2.571a.963.963 0 1 0-.964.964c.534 0 .964-.43.964-.964M12 14.57a2.572 2.572 0 0 1 0-5.142A2.574 2.574 0 0 1 14.571 12 2.574 2.574 0 0 1 12 14.571M12.964 12a.963.963 0 1 0-.964.964c.534 0 .964-.43.964-.964M12 3a2.573 2.573 0 0 1 0 5.143A2.573 2.573 0 0 1 12 3m-.964 2.571a.963.963 0 1 0 1.928 0 .963.963 0 1 0-1.928 0"
    }));
export default SvgEllipsisStrokeVertical;
